import { useState as R, useMemo as S, useLayoutEffect as b } from "react";
import { o as v, f as E, s as H, b as k, u as z, a as D, c as L, d as T, e as U } from "./floating-ui.react-87bo4V3_.js";
import { w as $ } from "./windowControlsClearance-BonpJzP6.js";
function B(p = {}) {
  const {
    placement: f = "bottom-start",
    offsetPx: n = 4,
    viewportPadding: t = 8,
    strategy: d = "fixed",
    constrainHeight: o = !0,
    reference: s = null,
    open: a,
    onOpenChange: u,
    dismiss: g
  } = p, [m, h] = R(!1), i = a !== void 0, r = i ? a : m, l = i ? u : h, x = S(() => {
    const c = [
      v(n),
      E({ padding: t }),
      H({ padding: t }),
      $()
    ];
    return o && c.push(k({
      padding: t,
      apply({ availableHeight: P, elements: M, middlewareData: F }) {
        const I = F.windowControlsClearance?.pushed ?? 0;
        M.floating.style.maxHeight = `${Math.max(0, P - I)}px`;
      }
    })), c;
  }, [o, n, t]), e = z({
    open: r,
    onOpenChange: l,
    placement: f,
    strategy: d,
    middleware: x,
    whileElementsMounted: D
  });
  b(() => {
    s && e.refs.setPositionReference(s);
  }, [e.refs, s]);
  const O = L(e.context, g), w = T(e.context, { role: "menu" }), { getReferenceProps: C, getFloatingProps: y } = U([O, w]);
  return {
    isOpen: r,
    setIsOpen: l,
    refs: e.refs,
    floatingStyles: e.floatingStyles,
    getReferenceProps: C,
    getFloatingProps: y,
    context: e.context
  };
}
export {
  B as u
};
//# sourceMappingURL=useTrackerFloatingMenu-DX8vovPt.js.map
